import React from 'react';
import { Link } from 'react-router-dom';
import Button from '../components/Button';
import Footer from 'components/Footer';

export default function Masaustu_tavsiyeler() {
  return (
    <div className="min-vh-100" style={{ backgroundColor: 'var(--sb-bg-muted)' }}>
      {/* Header */}
      <header className="header sticky-top" style={{ backgroundColor: 'var(--sb-bg)' }}>
        <nav className="navbar navbar-expand-lg">
          <div className="container">
            {/* Logo */}
            <Link className="navbar-brand fw-bold text-primary" to="/">
              <i className="fas fa-laptop me-2" />
              SadeceBilgisayar.com
            </Link>
            {/* Arama Kutusu */}
            <div className="search-box mx-lg-4 flex-grow-1">
              <form className="d-flex">
                <div className="input-group">
                  <input
                    aria-label="Arama"
                    className="form-control"
                    placeholder="Dizüstü, masaüstü, parça ara..."
                    type="search"
                  />
                  <Button className="btn btn-primary" type="submit">
                    <i className="fas fa-search" />
                  </Button>
                </div>
              </form>
            </div>
            {/* Sağ Menü */}
            <div className="nav-right">
              <Link className="btn btn-outline-primary me-2" to="/ilan-ver">
                <i className="fas fa-plus-circle me-2" />
                İlan Ver
              </Link>
              <Link className="btn btn-primary" to="/giris">
                <i className="fas fa-user me-2" />
                Giriş Yap
              </Link>
            </div>
          </div>
        </nav>
      </header>
 <main className="container py-5">
  {/* Masaüstü Bilgisayar Tavsiyeleri */}
  <section className="mb-5">
   <h2 className="mb-4 text-primary">
    <i className="fas fa-desktop me-2">
    </i>
    Masaüstü Bilgisayar Alırken Dikkat Edilmesi Gerekenler
   </h2>
   <div className="card">
    <div className="card-body">
     <p className="mb-4">
      <i className="fas fa-info-circle text-primary me-2">
      </i>
      <strong>
       İlk adım kullanım amacınızı belirlemek.
      </strong>
      Bunun için incelediğiniz ilanlara performans özellikleri kartı ekledik bu sayede en çok oynan oyunlarda ortalama olarak kaç fps alabileceğinizi ve en çok kullanılan iş programlarını bilgisayarın destekleyip desteklemediğini görebileceksiniz.
     </p>
     <p className="mb-4">
      <i className="fas fa-shield-alt text-primary me-2">
      </i>
      <strong>
       İkinci adım incelediğiniz ilanın sahibinin bilgisayar için Test video'su yüklemiş olması ve ilanın Test edildi rozetini taşıyor olması.
      </strong>
      Test edildi rozetini almak için Masaüstü ve Laptop bilgisayarlarda bu programların kullanılması gerekmektedir. Bu sayede bilgisayar donanımlarının sağlamlığı ve ilanın güvenirliliği büyük oranda sağlanmış olur.
     </p>
     {/* Yeni eklenen örnek video bölümü */}
     <div className="mt-3 mb-4">
      <h5 className="mb-3">
       Örnek Video
      </h5>
      <div className="ratio ratio-16x9">
       <iframe
         allowFullScreen
         src="https://www.youtube.com/embed/dQw4w9WgXcQ"
         title="Örnek Test Videosu"
       />
      </div>
     </div>
     <div className="mb-3">
      <p className="mb-4">
       <i className="fas fa-tasks text-primary me-2">
       </i>
       <strong>
        Kullanılan programların görevi yer almaktadır:
       </strong>
      </p>
      <div className="ms-4">
       <h5 className="text-primary mb-3">
        1. İşlemci Testi
       </h5>
       <p className="mb-3">
        İşlemcinin kararlılığını ve sıcaklığının görmek için CoreTemp ve Cpu-z programı kullanılır:
       </p>
       <ul className="list-unstyled mb-4">
        <li className="mb-2">
         <i className="fas fa-thermometer-half text-primary me-2">
         </i>
         CoreTemp: İşlemci sıcaklığını gösterir
        </li>
        <li className="mb-2">
         <i className="fas fa-microchip text-primary me-2">
         </i>
         Cpu-z: İşlemcinin detaylı özelliklerini gösterir ve stress testi özelliği vardır
        </li>
       </ul>
       <p className="mb-3">
        Test Adımları:
       </p>
       <ol className="mb-4">
        <li>
         Cpu-z programında bench kısmı seçilir ve stress cpu butonuna basılır
        </li>
        <li>
         Test bir kaç dakika çalıştırılır
        </li>
        <li>
         Sıcaklık kontrolü yapılır (70-75 derece normal, 80-85 derece üzeri riskli)
        </li>
       </ol>
       <div className="alert border mb-4">
        <i className="fas fa-exclamation-triangle text-primary me-2">
        </i>
        <strong>
         Not:
        </strong>
        İşlemciniz 80-85 dereceyi hızlı bir şekilde geçmeye başlarsa testi durdurunuz. İşlemci Termal macun değişimi gerekebilir. Bu test işlemcinize zarar vermemekte aksine yüksek sıcaklık kaynaklı oluşan işlemci ömrü ve performans düşüşü hakkında bize bilgi vermektedir.
       </div>
       <h5 className="text-primary mb-3 mt-4">
        2. RAM Testi
       </h5>
       <p className="mb-3">
        Techpowerup Memtest64 programı ile Windows üzerinde test yapılır:
       </p>
       <ol className="mb-4">
        <li>
         Tested memory kısmından maximum seçilir
        </li>
        <li>
         Stop after kısmına 2 yazılır
        </li>
        <li>
         Begin test ile test başlatılır
        </li>
        <li>
         Herhangi bir hata tespit edilmezse sağlamdır
        </li>
       </ol>
       <h5 className="text-primary mb-3">
        3. HDD/SSD Sağlamlık Testi
       </h5>
       <p className="mb-4">
        HDD Sentinel programı ile sistemdeki HDD ve SSD'lerin sağlık ve performans değerleri kontrol edilir.
       </p>
       <h5 className="text-primary mb-3">
        4. Ekran Kartı Testi
       </h5>
       <p className="mb-3">
        Geeks3D Furmark programı ile ekran kartı kararlılık testi yapılır:
       </p>
       <ol className="mb-3">
        <li>
         Graphics test kısmından FurMark(GL) veya FurMark(VK) seçilir
        </li>
        <li>
         Resolution seçeneğinden ekran çözünürlüğü ayarlanır
        </li>
        <li>
         Run butonu ile test başlatılır (3-10 dakika arası) test yapılır daha sonra durdurulur
        </li>
        <li>
         Test sırasında ekran da çizgiler ve kararma olmuyorsa ekran kartı kararlılığı iyi durumda diyebiliriz
        </li>
       </ol>
       <div className="alert border mb-4">
        <i className="fas fa-exclamation-triangle text-primary me-2">
        </i>
        <strong>
         Not:
        </strong>
        Ekran kartı sıcaklığı 70-75 derece arası normal kabul edilir, 85 derece üzerine çıkması durumunda testi durdurunuz. Bilgisayarınızda oyunlarda takılma donma gibi sorunlar oluşuyorsa ekran kartı termal macun değişimi gerekebilir. Bu test doğru bir şekilde yapıldığında ekran kartına zarar vermemektedir.
       </div>
       <p className="mt-3 text-muted fst-italic">
        <i className="fas fa-info-circle text-primary me-2">
        </i>
        En iyi test yöntemi, ekran kartı kullanımı yüksek oyunlarda birkaç saat test etmektir. Bu sayede sistemin genel kararlılığı hakkında da bilgi sahibi oluruz.
       </p>
       <h5 className="text-primary mb-3">
        5. Güç Kaynağı
       </h5>
       <div className="ms-4">
        <p className="mb-3">
         <i className="fas fa-bolt text-primary me-2">
         </i>
         Güç kaynağı kapasitesi sistemin en fazla çekebileceği watt değerinden
         <strong>
          en az 100-150 watt yüksek
         </strong>
         olması tavsiye edilmektedir.
        </p>
        <div className="card mb-4" style={{ backgroundColor: 'var(--sb-bg-muted)' }}>
         <div className="card-body">
          <h6 className="card-title">
           <i className="fas fa-calculator text-primary me-2">
           </i>
           Güç Hesaplama Örneği:
          </h6>
          <ul className="list-unstyled mb-3">
           <li className="mb-2">
            <i className="fas fa-microchip text-primary me-2">
            </i>
            İşlemci (i3 10100f): 65 watt
           </li>
           <li className="mb-2">
            <i className="fas fa-tv text-primary me-2">
            </i>
            Ekran Kartı (GTX 1650 Super): 85 watt
           </li>
           <li className="mb-2">
            <i className="fas fa-hdd text-primary me-2">
            </i>
            Diğer Bileşenler (Anakart, RAM, HDD, SSD, Fanlar): ~70 watt
           </li>
          </ul>
          <div className="alert alert-info mb-0">
           <i className="fas fa-info-circle text-primary me-2">
           </i>
           <strong>
            Toplam Güç Tüketimi:
           </strong>
           <span>
            220 watt
           </span>
           <br/>
           <strong>
            Önerilen Güç Kaynağı:
           </strong>
           <span>
            350-400 watt
           </span>
          </div>
         </div>
        </div>
        <div className="alert border mb-4">
         <i className="fas fa-exclamation-triangle text-primary me-2">
         </i>
         <strong>
          Önemli Not:
         </strong>
         Güç kaynaklarında sertifika önemlidir fakat sertifikasız güç kaynaklarının tamamının kötü olduğu anlamına gelmez. Alacağınız markanın modelini forumlarda ve youtube üzerinde mutlaka araştırınız.
        </div>
       </div>
      </div>
     </div>
    </div>
   </div>
  </section>
  {/* Laptop Tavsiyeleri */}
  <section className="mb-5">
   <h2 className="mb-4 text-primary">
    <i className="fas fa-laptop me-2">
    </i>
    Laptop Alırken Dikkat Edilmesi Gerekenler
   </h2>
   <div className="card">
    <div className="card-body">
     <p className="mb-4">
      <i className="fas fa-info-circle text-primary me-2">
      </i>
      Laptop alırken masaüstü bilgisayardan farklı olarak aşağıdaki fiziksel kontrollerin yapılması gerekmektedir:
     </p>
     <div className="ms-4">
      <div className="row g-4">
       {/* Kasa Kontrolü */}
       <div className="col-md-6">
        <div className="d-flex align-items-start">
         <i className="fas fa-laptop-medical text-primary mt-1 me-3">
         </i>
         <div>
          <h6 className="mb-2">
           Kasa Kontrolü
          </h6>
          <p className="text-muted">
           Laptop kasasında çatlak, kırık veya deformasyon kontrolü yapılır.
          </p>
         </div>
        </div>
       </div>
       {/* Klavye ve Touchpad */}
       <div className="col-md-6">
        <div className="d-flex align-items-start">
         <i className="fas fa-keyboard text-primary mt-1 me-3">
         </i>
         <div>
          <h6 className="mb-2">
           Klavye ve Touchpad
          </h6>
          <p className="text-muted">
           Tüm tuşların ve touchpad'in çalışması test edilir.
          </p>
         </div>
        </div>
       </div>
       {/* Ekran Kontrolü */}
       <div className="col-md-6">
        <div className="d-flex align-items-start">
         <i className="fas fa-desktop text-primary mt-1 me-3">
         </i>
         <div>
          <h6 className="mb-2">
           Ekran Kontrolü
          </h6>
          <p className="text-muted">
           Ekranda çizik veya ölü piksel kontrolü yapılır.
          </p>
         </div>
        </div>
       </div>
       {/* Güç Adaptörü */}
       <div className="col-md-6">
        <div className="d-flex align-items-start">
         <i className="fas fa-plug text-primary mt-1 me-3">
         </i>
         <div>
          <h6 className="mb-2">
           Güç Adaptörü
          </h6>
          <p className="text-muted">
           Adaptörün temas ve ısınma durumu kontrol edilir.
          </p>
         </div>
        </div>
       </div>
       {/* Kamera */}
       <div className="col-md-6">
        <div className="d-flex align-items-start">
         <i className="fas fa-camera text-primary mt-1 me-3">
         </i>
         <div>
          <h6 className="mb-2">
           Kamera Kontrolü
          </h6>
          <p className="text-muted">
           Kameranın çalışması test edilir.
          </p>
         </div>
        </div>
       </div>
       {/* Wifi */}
       <div className="col-md-6">
        <div className="d-flex align-items-start">
         <i className="fas fa-wifi text-primary mt-1 me-3">
         </i>
         <div>
          <h6 className="mb-2">
           Wifi Kontrolü
          </h6>
          <p className="text-muted">
           Wifi kartının çalışması test edilir.
          </p>
         </div>
        </div>
       </div>
       {/* Batarya Sağlığı ve Hoparlör Kontrolü yan yana olacak */}
       <div className="row align-items-start">
        {/* Hoparlör Kontrolü */}
        <div className="col-md-6">
         <div className="d-flex align-items-start mb-4">
          <i className="fas fa-volume-up text-primary mt-1 me-3">
          </i>
          <div>
           <h6 className="mb-2">
            Hoparlör Kontrolü
           </h6>
           <p className="text-muted">
            Hoparlörlerin ses kalitesi test edilir.
           </p>
          </div>
         </div>
        </div>
        {/* Batarya Sağlığı */}
        <div className="col-md-6 ps-md-4">
         <div className="d-flex align-items-start mb-4">
          <i className="fas fa-battery-full text-primary mt-1 me-3">
          </i>
          <div>
           <h6 className="mb-2">
            Batarya Sağlığı
           </h6>
           <p className="text-muted">
            Batarya sağlığı kontrol edilir.
           </p>
          </div>
         </div>
        </div>
       </div>
      </div>
     </div>
    </div>
   </div>
  </section>
  {/* Donanım Tavsiyeleri */}
  <section className="mb-5">
   <h2 className="mb-4 text-primary">
    <i className="fas fa-microchip me-2">
    </i>
    Donanım Alırken Dikkat Edilmesi Gerekenler
   </h2>
   <div className="card">
    <div className="card-body">
     <p className="mb-4">
      <i className="fas fa-microchip text-primary me-2">
      </i>
      <strong>
       İşlemci alırken
      </strong>
      anakartınızın o işlemciyi destekleyip desteklemediğini kontrol ediniz. Güç kaynağınızın yeni alacağınız işlemci için yeterli olup olmadığını hesaplayınız. Bilgisayarınızda bulunan işlemci soğutma fanının yeni alacağınız işlemci için yeterli olup olmayacağını araştırınız. En az orta kalite de ısı iletimi iyi olan bir termal macun modeli araştırınız.
     </p>
     <p className="mb-4">
      <i className="fas fa-memory text-primary me-2">
      </i>
      <strong>
       Ram Alırken
      </strong>
      anakartımızın modelini hafıza türü ve hangi hızı desteklediğini bilmemiz gerek bu sebeple Cpu-z programını indirip anakart modelini görebiliriz. Anakart modelini yazarak resmi sitesinden Desteklenen Hafıza türünü (DDR) ve frekans hızını (MHZ) görebiliriz.
     </p>
     <div className="alert border mb-4">
      <i className="fas fa-exclamation-triangle text-primary me-2">
      </i>
      <strong>
       Önemli:
      </strong>
      Serverlarda kullanılan ECC Ram alacaksanız eğer anakartınızın desteklediğine emin olunuz.
     </div>
     <p className="mb-4">
      <i className="fas fa-tv text-primary me-2">
      </i>
      <strong>
       Ekran kartı alırken
      </strong>
      güç tüketimini ve kaç pin güç girişi olduğuna dikkat ediniz. Güç kaynağınızın yeterli olup olmayacağını hesaplayınız ve ekran kartınızın için güç pini olup olmadığını kontrol ediniz. Güç kaynağınızın gücü yetmesine rağmen güç pini bağlantısı yok ise ekran kartı pin dönüştürücüsü kullanmanız gerekir.
     </p>
     <p className="mb-4">
      <i className="fas fa-hdd text-primary me-2">
      </i>
      <strong>
       HDD/SSD/M2 Alırken
      </strong>
      anakartınızın M2 SSD desteği olup olmadığını kontrol etmek için Cpu-z programından modelini öğrenip Üretici sayfa veya internet üzerinden araştırınız. Satıcıdan HDD sentiel programı üzerinden HDD, SSD VE M2 SSD için sağlık ve performans durumunu gözükecek şekilde fotoğraf isteyebilirsiniz.
     </p>
     <p className="mb-4">
      <i className="fas fa-server text-primary me-2">
      </i>
      <strong>
       Anakart alırken
      </strong>
      tüm usb internet portlarının çalışıp çalışmadığını ram slotlarının hepsinin çalıştığını satıcıya sorunuz.
     </p>
    </div>
   </div>
  </section>
 </main>
 <Footer />
    </div>
  );
}
